var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-wrapper",class:{ active: _vm.isSearchActive },on:{"click":_vm.activateSearch}},[(!_vm.isSearchActive)?_c('img',{staticClass:"search-icon",style:(_vm.searchIconStyle),attrs:{"src":_vm.isSearchActive ? _vm.searchIconActive : _vm.searchIconDisabled},on:{"click":_vm.activateSearch}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }